
export default function Services() {
  const services = [
    {
      icon: 'ri-car-line',
      title: 'Compra de Coches Siniestrados',
      description: 'Compramos coches siniestrados en Castelldefels sin importar el estado. Accidentados, chocados, volcados o con daños graves. Te damos el mejor precio del mercado por tu vehículo siniestrado.',
      features: ['Valoración en 1 hora', 'Pago inmediato', 'Cualquier marca y modelo']
    },
    {
      icon: 'ri-tools-line',
      title: 'Vehículos Averiados',
      description: 'Compramos coches averiados en Castelldefels: motor fundido, caja de cambios rota, problemas eléctricos graves. No importa la avería, te compramos el coche y te pagamos al instante.',
      features: ['Sin reparaciones necesarias', 'Recogida incluida', 'Gestión completa']
    },
    {
      icon: 'ri-time-line',
      title: 'Coches Antiguos y Sin ITV',
      description: 'Compramos coches antiguos, viejos y sin ITV en Castelldefels. Si tu coche lleva años parado, no pasa la ITV o está abandonado, te lo compramos y nos encargamos de todo.',
      features: ['Sin ITV necesaria', 'Documentación mínima', 'Proceso rápido']
    },
    {
      icon: 'ri-truck-line',
      title: 'Recogida Gratuita con Grúa',
      description: 'Servicio de grúa gratuito en Castelldefels para recoger tu coche siniestrado o averiado. No importa si no arranca, está accidentado o sin ruedas. Nos encargamos del transporte sin coste.',
      features: ['Grúa incluida gratis', 'Mismo día disponible', 'Toda Castelldefels']
    },
    {
      icon: 'ri-file-text-line',
      title: 'Gestión de Baja en DGT',
      description: 'Tramitamos la baja definitiva de tu coche siniestrado en la DGT. Te entregamos el certificado de destrucción oficial. Tú no tienes que hacer ninguna gestión ni papeleo.',
      features: ['Baja definitiva DGT', 'Certificado oficial', 'Sin gestiones para ti']
    },
    {
      icon: 'ri-money-euro-circle-line',
      title: 'Pago Inmediato',
      description: 'Pagamos al instante por tu coche siniestrado en Castelldefels. Efectivo o transferencia bancaria en el momento de la recogida. Sin esperas ni complicaciones. Dinero rápido y seguro.',
      features: ['Efectivo al instante', 'Transferencia inmediata', 'Pago garantizado']
    }
  ];

  return (
    <section id="servicios" className="py-12 sm:py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-16">
          <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-2 bg-teal-100 text-teal-700 rounded-full mb-3 sm:mb-4">
            <i className="ri-service-line text-base sm:text-lg"></i>
            <span className="text-xs sm:text-sm font-semibold whitespace-nowrap">NUESTROS SERVICIOS</span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4 px-2">
            Compramos <strong>Coches Siniestrados</strong> en Castelldefels
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-600 max-w-3xl mx-auto px-2">
            Servicio completo para la compra de vehículos siniestrados, averiados o para desguace. Recogida gratis, pago inmediato y gestión de baja incluida.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
          {services.map((service, index) => (
            <article
              key={index}
              className="bg-gray-50 rounded-xl sm:rounded-2xl p-5 sm:p-6 lg:p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-gray-100"
            >
              {/* Icon */}
              <div className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 flex items-center justify-center bg-teal-100 rounded-xl sm:rounded-2xl mb-4 sm:mb-6">
                <i className={`${service.icon} text-2xl sm:text-3xl text-teal-600`}></i>
              </div>

              {/* Title */}
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                {service.title}
              </h3>

              {/* Description */}
              <p className="text-gray-600 mb-4 sm:mb-6 leading-relaxed text-sm sm:text-base">
                {service.description}
              </p>

              {/* Features */}
              <ul className="space-y-1.5 sm:space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center gap-2 text-xs sm:text-sm text-gray-700">
                    <i className="ri-check-line text-teal-600 text-base sm:text-lg"></i>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>

        {/* Additional Info Section */}
        <div className="mt-10 sm:mt-16 bg-gradient-to-r from-teal-50 to-cyan-50 rounded-2xl sm:rounded-3xl p-5 sm:p-8 lg:p-12">
          <div className="max-w-4xl mx-auto">
            <h3 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900 mb-4 sm:mb-6 text-center">
              ¿Por Qué Vender tu Coche Siniestrado a Nuestro Desguace?
            </h3>
            <div className="grid sm:grid-cols-2 gap-4 sm:gap-6">
              <div className="flex gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-teal-600 rounded-full flex-shrink-0">
                  <i className="ri-shield-check-line text-xl sm:text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1 sm:mb-2 text-sm sm:text-base">Experiencia y Confianza</h4>
                  <p className="text-gray-600 text-xs sm:text-sm">Más de 15 años comprando coches siniestrados en Castelldefels. Servicio profesional y transparente.</p>
                </div>
              </div>
              <div className="flex gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-teal-600 rounded-full flex-shrink-0">
                  <i className="ri-speed-line text-xl sm:text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1 sm:mb-2 text-sm sm:text-base">Proceso Rápido</h4>
                  <p className="text-gray-600 text-xs sm:text-sm">Valoración en menos de 1 hora. Recogida el mismo día si lo necesitas. Pago inmediato.</p>
                </div>
              </div>
              <div className="flex gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-teal-600 rounded-full flex-shrink-0">
                  <i className="ri-hand-coin-line text-xl sm:text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1 sm:mb-2 text-sm sm:text-base">Mejor Precio</h4>
                  <p className="text-gray-600 text-xs sm:text-sm">Te damos el mejor precio del mercado por tu coche siniestrado. Valoración justa y competitiva.</p>
                </div>
              </div>
              <div className="flex gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-teal-600 rounded-full flex-shrink-0">
                  <i className="ri-file-shield-line text-xl sm:text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1 sm:mb-2 text-sm sm:text-base">Todo Legal</h4>
                  <p className="text-gray-600 text-xs sm:text-sm">Gestión completa de la baja en DGT. Certificado de destrucción oficial. Sin preocupaciones.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-8 sm:mt-12">
          <a
            href="#valoracion"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('valoracion')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 px-6 sm:px-8 py-3 sm:py-4 bg-teal-600 text-white rounded-full text-sm sm:text-lg font-semibold hover:bg-teal-700 transition-all shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-calculator-line text-lg sm:text-xl"></i>
            Solicitar Valoración Gratuita
          </a>
        </div>
      </div>
    </section>
  );
}
